import React, { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";

const SingleItem = ({ data }) => {
  const [livePrice, setLivePrice] = useState([]);
  const [loading, setLoading] = useState(true);
  const { forex_id: forexData } = data;

  useEffect(() => {
    const interval = setInterval(() => {
      fetchData();
    }, 1000);
    return () => clearInterval(interval);
  }, [livePrice]);

  const fetchData = async () => {
    if (forexData !== null) {
      fetch(
        `https://api.massive.com/v2/snapshot/locale/global/markets/forex/tickers/C:${forexData?.base_currency}${forexData?.quote_currency}?apiKey=${process.env.REACT_APP_POLYGON_API_KEY}`,
        {
          method: "GET",
        }
      )
        .then((res) => res.json())
        .then((data) => {
          if (data?.ticker) {
            setLivePrice(data?.ticker);
          }
          if (loading) {
            setLoading(false);
          }
        })
        .catch((error) => {
          // console.log(error);
        });
    }
  };

  if (loading || forexData === null) {
    return;
  }
  return (
    <>
      <div className="markets-coin">
        <Link to={`/user/live/trade/forex/${forexData?._id}`}>
          <div className="markets-coin-left">
            <div className="markets-coin-image">
              <LazyLoadImage
                effect="blur"
                alt="img"
                src={`https://api.wlfmobile.com/${forexData?.image}`}
                className="hot-coin-img"
              />
            </div>
            <div className="markets-coin-name">
              <h4>{forexData?.name}</h4>
              <h5>{forexData?.base_currency}</h5>
            </div>
          </div>
          <div className="markets-coin-right">
            <div className="markets-coin-price">
              {livePrice?.lastQuote?.a !== 0 && livePrice?.lastQuote?.a && (
                <p>
                  $
                  {!isNaN(livePrice?.lastQuote?.a) &&
                    parseFloat(livePrice?.lastQuote?.a) +
                      parseFloat(forexData?.price)}
                </p>
              )}
            </div>
           
            {livePrice?.lastQuote?.a !== 0 && livePrice?.lastQuote?.a && (
              <div className="markets-coin-percentage">
                <p
                  className={`${
                    livePrice?.todaysChangePerc >= 0 ? "up-price" : "dwon-price"
                  }`}
                >
                  <i class="fa-solid fa-arrow-right"></i>
                  {parseFloat(livePrice?.todaysChangePerc).toFixed(2)}%
                </p>
              </div>
            )}

             {livePrice?.lastQuote?.a === 0 ? (
                  <div className="market-closed">closed</div>
                ) : (
                  !livePrice?.lastQuote?.a && (
                    <div className="market-closed">closed</div>
                  )
                )}

          </div>
        </Link>
      </div>

     
    </>
  );
};

export default SingleItem;
